import React from "react";
import EventNoteIcon from "@mui/icons-material/EventNote";
import { useAppContext } from "Context/AppContext";
import { IconButton } from "@mui/material";
import ChevronRightTwoToneIcon from "@mui/icons-material/ChevronRightTwoTone";

export default function SideBar() {
  const { setShowNoteApp, toggleSideBar, toggleNoteApp } = useAppContext();
  const handleClick = () => {
    toggleSideBar();
    setShowNoteApp(false);
  };
  return (
    <div style={{ height: "100vh" }}>
      <div style={{ height: "85%" }}>
        <IconButton
          children={<EventNoteIcon />}
          sx={{ color: "black", ml: 1, mt: 1 }}
          onClick={toggleNoteApp}
        />
      </div>
      {/* <div>
        <IconButton
          children={<ChevronRightTwoToneIcon />}
          sx={{ color: "#888888", ml: 1 }}
          onClick={handleClick}
        />
      </div> */}
    </div>
  );
}
